import { createContext, useContext } from 'react'

export interface CartItem {
  variantId: number
  quantity: number
}

export interface CartContextValue {
  items: CartItem[]
  itemCount: number
  addItem: (variantId: number, quantity?: number) => void
  setQuantity: (variantId: number, quantity: number) => void
  removeItem: (variantId: number) => void
  clearCart: () => void
}

export const CartContext = createContext<CartContextValue | undefined>(undefined)

export const useCart = () => {
  const context = useContext(CartContext)
  if (!context) throw new Error('useCart doit être utilisé dans CartProvider')
  return context
}
